module.exports = __webpack_public_path__ + "media/1.508e23f1.mp3";